module.exports = __webpack_public_path__ + "img/scheda_controllo.a7c305f1.jpg";